import { z } from "zod";
export const WebPriceSchema = z.object({
    stripePriceId: z.string(),
    trialPeriodDays: z.number().optional()
});
export const StripePriceSchema = z.object({
    id: z.string(),
    currency: z.string(),
    recurring: z.object({
        interval: z.enum([
            "day",
            "week",
            "month",
            "year"
        ]),
        interval_count: z.number()
    }).nullable().optional(),
    unit_amount: z.number()
});
export const PublicWebPriceSchema = WebPriceSchema.extend({
    stripePrice: StripePriceSchema
});
export const WebProductSchema = z.object({
    id: z.number().optional(),
    name: z.string(),
    stripeProductId: z.string(),
    stripeProductRank: z.number(),
    applicationId: z.number(),
    prices: z.array(WebPriceSchema)
});
export const PublicStripeProductSchema = z.object({});
export const PublicWebProductSchema = WebProductSchema.omit({
    prices: true
}).extend({
    prices: z.array(PublicWebPriceSchema),
    stripeProduct: PublicStripeProductSchema
});
